import React, { Component, PureComponent } from 'react';
import { Childrens } from '../../core/api/models';
import { DropdownList } from 'react-widgets';

interface Props {
  placeholder?: string;
  onChange: (val?: ChildInterface) => void;
  value: ChildInterface;
  className?: string;
  disabled?: boolean;
}

interface SingleProps {
  onChange: (val: Childrens) => void;
  value: Childrens;
  disabled?: boolean;
}

interface ChildInterface {
  numberOfChildren: number;
  children: Childrens[];
}

interface State {
  numberOfChildren: number;
  children: Childrens[];
  showChildren: boolean;
}

interface SingleState {
  value: Childrens;
}

class SinglePhoneInput extends PureComponent<SingleProps, SingleState> {
  constructor(props: SingleProps) {
    super(props);
    this.state = {
      value: this.props.value,
    };
  }
  setName = (e: { target: { value: string } }) => {
    const { value } = this.state;
    value.name = e.target.value;
    this.setState({ value });
    this.props.onChange(value);
  };

  setAge = (e: { target: { value: string } }) => {
    const { value } = this.state;
    value.age = Number(e.target.value) > 0 ? Number(e.target.value) : 0;
    this.setState({ value });
    this.props.onChange(value);
  };

  setGender = (gender: { label: string; value: string }) => {
    const { value } = this.state;
    value.gender = gender.value;
    this.setState({ value });
    this.props.onChange(value);
  };

  render() {
    return (
      <div className="row gutter-5 mb-2">
        <div className="col-6 input-group ">
          <input
            type="text"
            placeholder="Name"
            className="font-sm font-weight-semibold form-control"
            value={this.state.value.name}
            name="name"
            id="name"
            onChange={this.setName}
            disabled={this.props.disabled}
          />
        </div>
        <div className="col-3">
          <input
            type="number"
            placeholder="Age"
            className="font-sm font-weight-semibold form-control"
            value={this.state.value.age}
            name="age"
            id="age"
            onChange={this.setAge}
            min={1}
            disabled={this.props.disabled}
          />
        </div>

        <div className="col-3">
          <DropdownList
            value={this.props.value.gender || 'male'}
            data={[
              { label: 'Male', value: 'male' },
              { label: 'Female', value: 'female' },
            ]}
            defaultValue={this.props.value.gender || 'male'}
            textField={'label'}
            valueField={'value'}
            placeholder={'Select Gender'}
            onChange={this.setGender}
            disabled={this.props.disabled}
          />
        </div>
      </div>
    );
  }
}

// tslint:disable-next-line: max-classes-per-file
class OtpInput extends Component<Props, State> {
  static defaultProps = {
    value: {
      numberOfChildren: 0,
      children: null,
    },
  };

  state = {
    numberOfChildren: this.props.value?.numberOfChildren || 0,
    children:
      this.props.value &&
      this.props.value.children &&
      this.props.value.children.length > 0
        ? this.props.value.children
        : [
            {
              name: '',
              age: undefined,
              gender: 'Male',
            },
          ],
    showChildren: false,
  };

  addMoreChildren = () => {
    this.setState({ showChildren: true });
  };

  handleOnChange = (child: Childrens, index: number) => {
    const { onChange } = this.props;
    const { children, numberOfChildren } = this.state;
    if (children && children !== undefined) {
      children[index] = child;
    }
    this.setState({ children });

    onChange({ numberOfChildren, children });
  };

  renderInputs = () => {
    const { children, numberOfChildren } = this.state;

    const inputs = [];

    for (let i = 0; i < numberOfChildren; i++) {
      inputs.push(
        <SinglePhoneInput
          onChange={(value: Childrens) => this.handleOnChange(value, i)}
          value={children[i]}
          disabled={this.props.disabled}
        />
      );
    }

    return inputs;
  };

  setNumberOfChildren = (e: { value: number }) => {
    const { numberOfChildren } = this.state;
    const { value } = this.props;
    value.numberOfChildren = e.value;
    const arrayNumberToAdd = !numberOfChildren
      ? e.value
      : e.value - value.children.length;
    if (numberOfChildren === 0) {
      value.children = [];
    }
    if (arrayNumberToAdd < 0) {
      value.children.splice(arrayNumberToAdd, Math.abs(arrayNumberToAdd));
    }
    for (let i = 0; i < arrayNumberToAdd; i++) {
      value.children.push({
        name: '',
        age: undefined,
        gender: 'Male',
      });
    }

    this.setState({ numberOfChildren: e.value, children: value?.children });
    this.props.onChange(value);
  };

  render() {
    return (
      <>
        <div className="row gutter-5 mb-2">
          <div className="col input-group ">
            <DropdownList
              value={this.props.value?.numberOfChildren || 0}
              data={[
                { value: 0, label: '0' },
                { value: 1, label: '1' },
                { value: 2, label: '2' },
                { value: 3, label: '3' },
                { value: 4, label: '4' },
                { value: 5, label: '5' },
                { value: 6, label: '6' },
                { value: 7, label: '7' },
                { value: 8, label: '8' },
                { value: 9, label: '9' },
                { value: 10, label: '10' },
              ]}
              defaultValue={this.props.value?.numberOfChildren || 0}
              textField={'label'}
              valueField={'value'}
              placeholder={'Select Number of children'}
              onChange={this.setNumberOfChildren}
              disabled={this.props.disabled}
            />
          </div>
        </div>
        {/* {this.state.numberOfChildren === 0 && (
          <button
            type="button"
            className="btn btn-link font-sm p-0 font-weight-semibold mb-2"
            onClick={this.addMoreChildren}
          >
            + Map Children Info
          </button>
        )} */}

        {(this.state.showChildren || this.props.value?.children?.length > 0) &&
          this.renderInputs()}
      </>
    );
  }
}

export default OtpInput;
